import React from 'react';
import styled from 'styled-components';

const StyledImgIcon = styled.img`
  max-height: 16px;
  width: 20px;
`;

const RankIcon = ({ rank }) => {
  if (!rank || !rank.icon?.present) return null;

  return <StyledImgIcon src={rank.icon.url} alt={rank.name} title={rank.name} />;
};

export default RankIcon;
